import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import classes from './DialogMessage.module.css';

const DialogMessage = props => {
  const { t } = useTranslation(['ui']);
  return (
    <Dialog onClose={props.handleClose} open={props.open}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={props.handleClose}
          className={classes.acceptBtn}
        >
          {t('accept')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DialogMessage.propTypes = {
  // eslint-disable-next-line react/require-default-props
  message: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  title: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  handleClose: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  open: PropTypes.bool
};

export default DialogMessage;
